export class ServerBaseEntity<T extends ServerBaseEntityI<TId>, TId = number> implements ServerBaseEntityI<TId> {
  id: TId = undefined;
  createdBy: number = undefined;
  createdOn: string = undefined;
  updatedBy: number = undefined;
  updatedOn: string = undefined;

  constructor(params?: Partial<T>) {
    if (params) {
      Object.assign(this, params);
    }
  }

}
